export default __webpack_public_path__ + "static/media/alerts.46390b73.svg";